import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/CSEASH202mid21.pdf'
import cse from '../assets/CSEASH202end21.pdf'

export default function M_2() {
  return (
    <div>
       <Subject title="Mathematics-2(ASH202)" mid="Q. Paper"
    book1="P.G.Hoel, S.C.Port and C.J.Stone, Introduction to Probability Theory, Universal Book Stall, 2003"
    book2="Erwin Kreyszig, Advanced Engineering Mathematics, 9th Edition, John Wiley & Sons, 2006 "
    book1Link="http://www.ru.ac.bd/stat/wp-content/uploads/sites/25/2019/03/302_01_Hoel_Introduction_to_Mathematical_Statistics.pdf" 
    book2Link="https://physicaeducator.files.wordpress.com/2017/11/erwin_kreyszig-_advanced_engineering_mathematics.pdf"
    int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}